import React, { Component } from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';
import ASRSaveRegexStringDialog from './ASRSaveRegexStringDialog';
import Overlay from '../../../../presentation/Overlay';
import ASRDeleteRegexStringDialog from './ASRDeleteRegexStringDialog';
import Loading from '../../../../presentation/Loading';

class ASRProjectDialog extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      regexString: this.props.selectedRegexString.Regex_String,
      orderId: this.props.isNew ? 1 : this.props.selectedRegexString.Order_ID,
      groupName: this.props.isNew ? this.props.asrGroupNames[ 0 ].Group_Name : this.props.selectedRegexString.Group_Name,
      asrResult: this.props.isNew ? 'Crosstalk' : this.props.selectedRegexString.Result,
      asrGroupNames: this.props.asrGroupNames,
      testRegexString: '',
      allPrograms: [],
      phraseFound: false,
      showSaveRegexStringDialog: false,
      showDeleteDialog: false,
      saving: false,
      isValidRegex: true
    };

    this.onChangeEvent = this.onChangeEvent.bind( this );
    this.onClickSaveButton = this.onClickSaveButton.bind( this );
    this.onClickResetButton = this.onClickResetButton.bind( this );
    this.onClickDeleteButton = this.onClickDeleteButton.bind( this );
    this.onClickCloseDialogs = this.onClickCloseDialogs.bind( this );
    this.onClickConfirmSaveDialog = this.onClickConfirmSaveDialog.bind( this );
    this.onClickConfirmDeleteDialog = this.onClickConfirmDeleteDialog.bind( this );

    this.alerts = new Alerts( props.bugsnag, props.dispatch );
    this.wijmoGrid = React.createRef();
    this.wijmoPanel = undefined;
    this.title = 'ASR Regex Edit';
  }

  componentDidMount() {
    const allProgramsPromise = this.apiPrograms( 'GET', [] );

    this.mounted = true;

    this.mounted && Promise.all( [ allProgramsPromise ] )
      .then( ( [ allProgramsResults ] ) => {
        allProgramsResults = allProgramsResults.map( ( program ) => {
          return `${program.PDNIS} - ${program.PROGRAM_NAME}`;
        } ).sort();

        this.mounted && this.setState( {
          allPrograms: allProgramsResults
        } );
      } )
      .catch( ( exception ) => {
        this.onHandleException( exception );
      } );
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  /********************************************************************************************************************
   * API EVENTS
   *******************************************************************************************************************/

  apiPrograms( request, params ) {
    switch ( request ) {
      case 'GET':
        return new EtelAPI( 'programs' ).get( params );
      default:
        break;
    }
  }

  /********************************************************************************************************************
   * HELPER FUNCTIONS
   *******************************************************************************************************************/

  doLogOff() {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;

    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const status = e.status === undefined ? 0 : e.status;

    if ( status === 410 ) {
      this.alerts.INFO( this.title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      this.alerts.INFO( this.title, e.statusText, 5000 );
    } else {
      if ( e.statusText !== undefined ) {
        this.alerts.CRITICAL( this.title, e, false );
      } else {
        this.alerts.CRITICAL( this.title, e );
      }
    }
  }

  /********************************************************************************************************************
   * EVENT HANDLERS
   *******************************************************************************************************************/

  /**
   * Event for closing any dialogs that this component renders.
   */
  onClickCloseDialogs( e ) {
    this.setState( {
      showSaveRegexStringDialog: false,
      showDeleteDialog: false
    } );
  }

  /**
   * Event for confirming the save dialog of the regex string. Preps the regex string data and passes it to the
   * parent component.
   */
  onClickConfirmSaveDialog( e ) {
    const updatedAsrRegexString = {
      Regex_String_ID: this.props.selectedRegexString.Regex_String_ID,
      Group_Name: this.state.groupName,
      Result: this.state.asrResult,
      Order_ID: this.state.orderId,
      Regex_String: this.state.regexString,
      ASR_Project_ID: this.props.selectedRegexString.ASR_Project_ID
    };

    this.setState( {
      showSaveRegexStringDialog: false,
      saving: true
    }, () => {
      this.props.onSave( updatedAsrRegexString );
    } );
  }

  /**
   * Event for confirming the delete dialog of the regex string. Passes the Regex_String_ID to the parent component to
   * handle the deletion.
   */
  onClickConfirmDeleteDialog( e ) {
    this.setState( {
      showDeleteDialog: false,
      saving: true
    }, () => {
      this.props.onDelete( this.props.selectedRegexString.Regex_String_ID );
    } );
  }

  /**
   * Event for all onChange handlers.
   */
  onChangeEvent( e ) {
    const targetName = e.target.name;
    const targetValue = e.target.value;

    this.setState( {
      [ targetName ]: targetValue,
    }, () => {
      if ( [ 'testRegexString', 'regexString' ].includes( targetName ) ) {
        let regex = undefined;
        let isValidRegex = true;
        let found = false;

        try {
          regex = new RegExp( this.state.regexString, 'g' );
          found = regex.test( this.state.testRegexString );
        } catch ( exception ) {
          isValidRegex = false;
        }

        this.setState( {
          phraseFound: found,
          isValidRegex: isValidRegex
        } );
      }
    } );
  }

  /**
   * Event for clicking the save button. Opens a new dialog for confirmation.
   */
  onClickSaveButton( e ) {
    const haveChanges = this.state.regexString !== this.props.selectedRegexString.Regex_String ||
      this.state.orderId !== this.props.selectedRegexString.Order_ID ||
      this.state.groupName !== this.props.selectedRegexString.Group_Name ||
      this.state.asrResult !== this.props.selectedRegexString.Result;

    if ( haveChanges ) {
      this.setState( {
        showSaveRegexStringDialog: true
      } );
    } else {
      this.alerts.INFO( this.title, 'No changes have been made', 3000 );
    }
  }

  /**
   * Event for clicking the reset button. Resets values for the regex string to it's original.
   */
  onClickResetButton( e ) {
    this.setState( {
      regexString: this.props.selectedRegexString.Regex_String,
      orderId: this.props.selectedRegexString.Order_ID,
      groupName: this.props.selectedRegexString.Group_Name,
      asrResult: this.props.selectedRegexString.Result,
    } );
  }

  /**
   * Event for clicking the delete button. Opens a new dialog for confirmation.
   */
  onClickDeleteButton( e ) {
    this.setState( {
      showDeleteDialog: true
    } );
  }

  /********************************************************************************************************************
   * RENDERS
   *******************************************************************************************************************/

  renderAsrResultOptions() {
    const asrResultOptions = [
      'EqPositive',
      'Positive',
      'EqNegative',
      'Negative',
      'Crosstalk',
      'Rebuttal',
      'Rebuttal2',
      'Age',
      'Numeric'
    ].map( ( asrResult ) => {
      return (
        <option key={asrResult} value={asrResult}>{asrResult}</option>
      );
    } );

    asrResultOptions.push(
      <option disabled key={'----------'}>----------</option>
    );

    return asrResultOptions.concat( this.state.allPrograms.map( ( program ) => {
      return (
        <option key={program} value={program.split( '-' )[ 0 ].trim()}>{program}</option>
      );
    } ) );
  }

  renderAsrGroupNameFilterOptions() {
    const asrGroupNameFilterOptions = this.state.asrGroupNames.map( ( groupName ) => {
      return (
        <option key={groupName.ASR_Group_Name_ID} value={groupName.Group_Name}>
          {groupName.Group_Name}
        </option>
      );
    } );

    return asrGroupNameFilterOptions;
  }

  renderDialogBody() {
    const projectName = this.props.selectedRegexString.Project_Name;
    const groupName = this.props.selectedRegexString.Group_Name;
    const result = this.props.selectedRegexString.Result;
    const orderId = this.props.selectedRegexString.Order_ID;

    return (
      <div className='asr-regex-dialog-body'>
        <div className='asr-regex-dialog-body-header'>
          <span className='asr-regex-dialog-body-header-cell'>
            <span className='asr-regex-dialog-body-header-label'>Project Name:</span>
            <span className='asr-regex-dialog-body-header-value'>{projectName}</span>
          </span>
          <span className='asr-regex-dialog-body-header-cell'>
            <span className='asr-regex-dialog-body-header-label'>Group Name:</span>
            <span className='asr-regex-dialog-body-header-value'>{groupName}</span>
          </span>
          <span className='asr-regex-dialog-body-header-cell'>
            <span className='asr-regex-dialog-body-header-label'>Result:</span>
            <span className='asr-regex-dialog-body-header-value'>{result}</span>
          </span>
          <span className='asr-regex-dialog-body-header-cell'>
            <span className='asr-regex-dialog-body-header-label'>Order:</span>
            <span className='asr-regex-dialog-body-header-value'>{orderId}</span>
          </span>
        </div>
        <div className='asr-regex-dialog-input-options-container'>
          <label>Order:</label>
          <input name='orderId' type='number' value={this.state.orderId} onChange={this.onChangeEvent} className='asr-regex-dialog-input-options-control' />
        </div>
        <div className='asr-regex-dialog-input-options-container'>
          <label>Group Name:</label>
          <select name='groupName' onChange={this.onChangeEvent} value={this.state.groupName} className='asr-regex-dialog-input-options-control'>
            {this.renderAsrGroupNameFilterOptions()}
          </select>
        </div>
        <div className='asr-regex-dialog-input-options-container'>
          <label>Result:</label>
          <select name='asrResult' onChange={this.onChangeEvent} value={this.state.asrResult} className='asr-regex-dialog-input-options-control'>
            {this.renderAsrResultOptions()}
          </select>
        </div>
        <div className='asr-regex-dialog-input-options-container'>
          <span>
            <label>Test Regex String:</label>
            {
              this.state.testRegexString
              &&
              <label className={`asr-regex-dialog-test-regex-string-label-${this.state.phraseFound}`}>{this.state.phraseFound ? 'Phrase was found in the regex string' : 'Phrase was not found in the regex string'}</label>
            }
          </span>
          <input name='testRegexString' value={this.state.testRegexString} onChange={this.onChangeEvent} />
        </div>
        <div className='asr-regex-dialog-input-options-container'>
          <span>
            <label>Regex String:</label>
            <label className={`asr-regex-dialog-test-regex-string-label-${this.state.isValidRegex}`}>{this.state.isValidRegex ? 'Regex string is valid' : 'Invalid regex string'}</label>
          </span>
          <textarea name='regexString' className='asr-regex-dialog-regex-string-textarea' value={this.state.regexString} onChange={this.onChangeEvent} />
        </div>
      </div>
    );
  }

  renderDialogFooter() {
    return (
      <span className='asr-dialog-footer'>
        {
          !this.props.isNew
          &&
          <button
            className='asr-dialog-footer-delete-button'
            onClick={this.onClickDeleteButton}
            disabled={this.state.saving || !this.mounted}
          >
            Delete
          </button>
        }
        {
          !this.props.isNew
          &&
          <button
            className='asr-dialog-footer-reset-button'
            onClick={this.onClickResetButton}
            disabled={this.state.saving || !this.mounted}
          >
            Reset
          </button>
        }
        <button
          className='asr-dialog-footer-cancel-button'
          onClick={this.props.onClose}
        >
          Cancel
        </button>
        <button
          className='asr-dialog-footer-save-button'
          onClick={this.onClickSaveButton}
          disabled={this.state.saving || !this.mounted || !this.state.isValidRegex}
        >
          Save
        </button>
      </span>
    );
  }

  render() {
    const orderId = this.props.selectedRegexString.Order_ID;
    const showOverlay = this.state.showSaveRegexStringDialog || this.state.showDeleteDialog;
    let orderIdMessage = `Order will remain at ${this.props.selectedRegexString.Order_ID}`;
    let asrResultMessage = `Result will remain ${this.props.selectedRegexString.Result}`;
    let groupNameMessage = `Group will remain ${this.props.selectedRegexString.Group_Name}`;
    let regexStringMessage = `Regex string will remain unchanged`;

    if ( this.props.isNew ) {
      orderIdMessage = `Order will be ${this.state.orderId}`;
      asrResultMessage = `Result will be ${this.state.asrResult}`;
      groupNameMessage = `Group will be ${this.state.groupName}`;
      regexStringMessage = `New regex string will be created`;
    } else {
      if ( parseInt( this.state.orderId, 10 ) !== parseInt( orderId, 10 ) ) {
        orderIdMessage = `Order will be updated to ${this.state.orderId}`;
      }

      if ( this.state.asrResult !== this.props.selectedRegexString.Result ) {
        asrResultMessage = `Result will be updated to ${this.state.asrResult}`;
      }

      if ( this.state.groupName !== this.props.selectedRegexString.Group_Name ) {
        groupNameMessage = `Group will be updated to ${this.state.groupName}`;
      }

      if ( this.state.regexString !== this.props.selectedRegexString.Regex_String ) {
        regexStringMessage = `Regex string has been modified and will be updated`;
      }
    }

    return (
      <Dialog show={this.props.show} width={90} height={90} >
        <DialogHeader caption={'Regex Edit'} closeButton onClose={this.props.onClose} />
        <DialogBody>
          {
            this.mounted && !this.state.saving
              ? this.renderDialogBody()
              : (
                <div className='asr-loading-container'>
                  <Loading caption='Loading please wait...' width='250px' />
                </div>
              )
          }
        </DialogBody>
        <DialogFooter>
          {
            this.renderDialogFooter()
          }
        </DialogFooter>
        {
          this.state.showSaveRegexStringDialog
          &&
          <ASRSaveRegexStringDialog
            show={this.state.showSaveRegexStringDialog}
            orderIdMessage={orderIdMessage}
            asrResultMessage={asrResultMessage}
            groupNameMessage={groupNameMessage}
            regexStringMessage={regexStringMessage}
            onClose={this.onClickCloseDialogs}
            onSave={this.onClickConfirmSaveDialog}
          />
        }
        {
          this.state.showDeleteDialog
          &&
          <ASRDeleteRegexStringDialog
            show={this.state.showDeleteDialog}
            onConfirm={this.onClickConfirmDeleteDialog}
            onClose={this.onClickCloseDialogs}
          />
        }
        {
          showOverlay
          &&
          <Overlay
            show={showOverlay}
          />
        }
      </Dialog>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( ASRProjectDialog ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/asr/components/ASRRegexDialog.js